import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const spellingBeeBadgeDefinition: BoggleBadgeDefinition = {
  category: 'mastery',
  description: 'Play a word of length 7+ without backspace',
  iconId: 'spellingBee',
  id: 'spellingBee',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Spelling Bee',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
